"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var typography = {
  fontFamily: "'Gilroy', sans-serif"
};
exports["default"] = typography;